import type { SVGAttributes } from "react";
import { Box } from "@hightouch/htui";

// Unread-dot geometry, shared by `AgentAwaitingReplyMarker`. The dot sits in
// the button's top-right corner.
export const ACTIVE_MARKER_SIZE_PX = 8;
export const ACTIVE_MARKER_TOP_PX = 2;
export const ACTIVE_MARKER_RIGHT_PX = 2;

export const ActiveMarkerIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg viewBox="0 0 8 8" {...props}>
    <circle cx="4" cy="4" r="4" fill="currentColor" />
  </svg>
);

export const ActiveMarkerOverlay = () => (
  <Box
    pos="absolute"
    top={`${ACTIVE_MARKER_TOP_PX}px`}
    right={`${ACTIVE_MARKER_RIGHT_PX}px`}
    w={`${ACTIVE_MARKER_SIZE_PX}px`}
    h={`${ACTIVE_MARKER_SIZE_PX}px`}
    color="primary.base"
    pointerEvents="none"
  >
    <ActiveMarkerIcon />
  </Box>
);
